export default {
  data() {
    return {
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
        },
        {
          title: '类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '文件编号',
          dataIndex: 'code',
        },
        {
          title: '文件名',
          dataIndex: 'fileName',
        },
        {
          title: '保险公司名称',
          dataIndex: 'insuranceName',
        },
        {
          title: '生效日期',
          dataIndex: 'efficientDate',
        },
        {
          title: '到期日期',
          dataIndex: 'expireDate',
        },
        {
          title: '货币单位',
          dataIndex: 'currencyUnit',
          scopedSlots: { customRender: 'currencyUnit' },
        },
        {
          title: '保险金额(元)',
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
        {
          title: '编辑日期',
          dataIndex: 'updateTime',
        },
        {
          title: '上传人',
          dataIndex: 'operator',
        },
        {
          title: '操作',
          fixed: 'right',
          width: 220,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      TYPE_1: 1,
      TYPE_2: 2,
      TYPE_3: 3,
      TYPE_4: 4,
      TYPE_5: 5,
      TYPE_6: 6,
      TYPE_NAME_OBJ: {
        1: '保险',
      },
    }
  },
}
